import { Fragment, ReactNode, Ref } from "react";
import WaveDivider from "@/components/WaveDivider";

type SectionBg = "achtergrond" | "white";

const BGS: SectionBg[] = ["achtergrond", "white"];

const BG_CLASSES: Record<SectionBg, string> = {
  achtergrond: "bg-achtergrond",
  white: "bg-white",
};

const BG_COLORS: Record<SectionBg, string> = {
  achtergrond: "#f0f9ff",
  white: "#ffffff",
};

export interface SectionItem {
  content: ReactNode;
  ref?: Ref<HTMLDivElement>;
}

interface WaveSectionsProps {
  sections: (SectionItem | false | null | undefined)[];
  startBg?: SectionBg;
}

export default function WaveSections({
  sections,
  startBg = "achtergrond",
}: WaveSectionsProps) {
  const items = sections.filter(Boolean) as SectionItem[];
  const startIndex = BGS.indexOf(startBg);

  return (
    <>
      {items.map((section, i) => {
        const bg = BGS[(startIndex + i) % 2];
        const prevBg = i > 0 ? BGS[(startIndex + i - 1) % 2] : null;

        return (
          <Fragment key={i}>
            {prevBg !== null && (
              <WaveDivider
                topColor={BG_COLORS[prevBg]}
                bottomColor={BG_COLORS[bg]}
              />
            )}
            <div ref={section.ref} className={`${BG_CLASSES[bg]}${i === items.length - 1 ? " flex-1" : ""}`}>
              {section.content}
            </div>
          </Fragment>
        );
      })}
    </>
  );
}
